import React from 'react';

export interface SubPermissionCardProps {
  label: string;
  description: string;
  control: React.ReactNode;
  onToggle?: () => void;
}

// Indented sub-card shown when a report is enabled
export const SubPermissionCard: React.FC<SubPermissionCardProps> = ({ label, description, control, onToggle }) => (
  <div
    className={`flex items-center justify-between gap-4 p-3 rounded-lg border bg-muted/30 ml-4${onToggle ? ' cursor-pointer select-none' : ''}`}
    onClick={onToggle}
  >
    <div className="flex-1 min-w-0">
      <div className="text-sm font-medium">{label}</div>
      <p className="text-xs text-muted-foreground mt-0.5">{description}</p>
    </div>
    <div className="shrink-0" onClick={e => e.stopPropagation()}>{control}</div>
  </div>
);
